import { TAGS_FIELD_NAME } from '@ardoq/data-model';

export const INVENTORY_PAGE_SIZE = 100;
export const MAX_BLOCKS_IN_CACHE = 30;
export const TAGS_COLUMN = TAGS_FIELD_NAME;
